import { GridSize, GridSpacing } from '@material-ui/core';

import { useScreen } from '@/hooks/useScreen';

interface TableLayoutStyle {
  tableSpacing: GridSpacing;
  actionsWidth: number | string;
  getItemSizes: (index: number) => GridSize;
}

export const useTableLayoutStyle = () => {
  const { sm } = useScreen();

  const itemSizes = [1, 7, 2, 2];

  return {
    tableSpacing: 2,
    actionsWidth: sm ? '76px' : '100%',
    getItemSizes: (index: number) => itemSizes[index],
  } as TableLayoutStyle;
};
